import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/company.svg'


const _hoisted_1 = { class: "compopts btm-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"80px","margin-right":"20px"},
  alt: "companyimg",
  title: "companyimg"
}, null, -1)
const _hoisted_3 = { class: "font-bold-24 namebreak" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LicenseAdminsList = _resolveComponent("LicenseAdminsList")!
  const _component_DashboardCards = _resolveComponent("DashboardCards")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_CompanySubscriptions = _resolveComponent("CompanySubscriptions")!
  const _component_CompanyUsers = _resolveComponent("CompanyUsers")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.companyData.companyName), 1)
    ]),
    _createVNode(_component_LicenseAdminsList),
    _createVNode(_component_DashboardCards, { showHeader: false }),
    _createVNode(_component_el_tabs, {
      modelValue: _ctx.activeTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
      class: "mt-3",
      type: "card"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "Licensed Products",
          name: "products",
          disabled: ""
        }),
        _createVNode(_component_el_tab_pane, {
          label: "Credential-based Products",
          name: "Credential-based"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CompanySubscriptions)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "Users",
          name: "users"
        }, {
          default: _withCtx(() => [
            (_ctx.activeTab === 'users')
              ? (_openBlock(), _createBlock(_component_CompanyUsers, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}